import React, { useEffect, useState } from 'react'
import { Grid, Container } from '@material-ui/core'
import HoldCoCard from './holdCoCard/holdCoCard'
import UserContainer from './holdCoCard/users/userContainer'
import { getData } from './actions'

export function HoldCoPage () {
  const [cardName, setCardName] = useState(null)
  const [userRecords, setUserRecords] = useState('Loading...')
  const [projectRecords, setProjectRecords] = useState('Loading...')
  const [vendorRecords, setVendorRecords] = useState('Loading...')
  const [departmentRecords, setDepartmentRecords] = useState('Loading...')
  useEffect(() => {
    totalRecords('/userInfo/userList')
  }, [])

  const totalRecords = async arg => {
    const { data } = await getData(arg)
    if (arg === '/projects') {
      setProjectRecords(data.length)
    } else if (arg === '/vendors') {
      setVendorRecords(data.length)
    } else if (arg === '/departments') {
      setDepartmentRecords(data.length)
    } else {
      setUserRecords(data.length)
    }
  }

  const holdCoCards = [
    {
      name: 'Users',
      description: `${userRecords} Records`
    }
  ]

  const renderData = data => {
    if (data === 'Users') {
      return <UserContainer handleBack={() => setCardName(null)} />
    } else if (data === 'Projects') {
      return <div>Projects</div>
    } else {
      return (
        <Grid container spacing={2}>
          {holdCoCards.map(card =>
            card.name === 'Users' ? (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                <HoldCoCard
                  clicked={() => {
                    setCardName(card.name)
                  }}
                  cardName={card.name}
                  cardDescription={card.description}
                  image='https://images.pexels.com/photos/1837605/pexels-photo-1837605.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500'
                />
              </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                <HoldCoCard
                  disabled={true}
                  clicked={() => {
                    setCardName(card.name)
                  }}
                  cardName={card.name}
                  cardDescription={card.description}
                  image='https://images.pexels.com/photos/1837605/pexels-photo-1837605.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500'
                />
              </Grid>
            )
          )}
        </Grid>
      )
    }
  }
  return <Container>{renderData(cardName)}</Container>
}
